<template>
 <div>
    <Teleport to="#settings-group-header">
      <T>API доставки</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <!-- <v-tabs v-model="tab">
        <v-tab><T>Провайдер геоданных</T></v-tab>
        <v-tab><T>Зоны доставки</T></v-tab>
      </v-tabs> -->
      <v-btn
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>

    <ApiIntegrations :config="$store.getters.local_refs" ref="form" :loading="loading" />

  </div>
</template>

<script>
import Teleport from 'vue2-teleport'
import ApiIntegrations from '../../components/settings/api_integrations'

export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {integrations: this.$refs.form.submit().integrations}
        
        await this.$store.dispatch('updateLocalRefs', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    ApiIntegrations
  }
}
</script>